import { Button, Card, Table, Typography } from 'antd';
import PropTypes from 'prop-types';

const columns = [
  {
    dataIndex: 'label',
    render: (value) => <Typography.Text type="secondary">{value}</Typography.Text>,
  },
  {
    align: 'right',
    dataIndex: 'value',
    render: (value) => <Typography.Text strong>{value}</Typography.Text>,
  },
];

const summaryTableStyles = {
  body: {
    cell: {
      borderBottom: 0,
    },
  },
};

export default function ContentSummaryCard({
  item,
  loading,
  size = undefined,
  type = undefined,
  variant = 'outlined',
}) {
  return (
    <Card
      extra={
        <Button type="link" href={item.href}>
          {`进入${item.title}`}
        </Button>
      }
      loading={loading}
      size={size}
      title={item.title}
      type={type}
      variant={variant}
    >
      <Table
        columns={columns}
        dataSource={item.rows}
        pagination={false}
        rowKey="label"
        showHeader={false}
        size="small"
        styles={summaryTableStyles}
        tableLayout="fixed"
      />
    </Card>
  );
}

ContentSummaryCard.propTypes = {
  item: PropTypes.shape({
    href: PropTypes.string,
    rows: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.node,
      }),
    ),
    title: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  size: PropTypes.oneOf(['default', 'small']),
  type: PropTypes.oneOf(['inner']),
  variant: PropTypes.oneOf(['outlined', 'borderless']),
};
